import { ProductBuilderState } from '../state';
import { ProductConfiguration, ProductCost, Product, productConfigurationTypePriceMultiplier } from '../../product';
import { ProductBuilderAction } from '.';
import { put, takeEvery } from 'redux-saga/effects';

function calcBase(state: ProductBuilderState): number {
    let base = 0;
    for (let configKey in state.product.configurationDefault) {
        if (!state.product.configurationDefault[configKey])
            break;
        state.product.configurationDefault[configKey].forEach(parameterValue => {
            if (!isNaN(parameterValue.price))
                base += parameterValue.price;
        });
    }
    return base;
}

export const productBuilderCostSet = (state: ProductBuilderState, params: { productConfiguration: ProductConfiguration; }): ProductBuilderState => {
    const cost: ProductCost[] = [];
    let subtotal = 0;
    let quantity = 1;
    let designCost = NaN;
    const typePriceMultiplier = productConfigurationTypePriceMultiplier(params.productConfiguration);
    cost.push({ group: 'base', summaryHidden: true, name: 'Base price', amount: calcBase(state), base: true });
    for (let configKey in params.productConfiguration) {
        if (!params.productConfiguration[configKey])
            break;
        params.productConfiguration[configKey].forEach(parameterValue => {
            if (configKey === 'quantity') {
                quantity = parseFloat(parameterValue.key);
                if (isNaN(quantity))
                    quantity = 1;
                return;
            }
            if (configKey === 'design') {
                switch (parameterValue.key) {
                    case 'own':
                    case 'library':
                        designCost = 0;
                        break;
                    case 'project':
                        designCost = state.product.designCost;
                        break;
                }
                return;
            }
            let valuePrice = parameterValue.price;
            if (!isNaN(valuePrice)) {
                if (configKey === 'fabrics')
                    valuePrice *= typePriceMultiplier;
                subtotal += valuePrice;
            }
            cost.push({ group: 'parameters', name: state.productParameterLabels[configKey], amount: valuePrice });
        });
    }
    if (state.productParameters.some(it => it.key === 'design'))
        cost.push({ group: 'other', name: 'Design', amount: designCost });
    let total = state.product.price;
    if (isNaN(total))
        total = 0;
    total += subtotal;
    total *= quantity;
    if (!isNaN(designCost))
        total += designCost;
    cost.push({ group: 'summary', name: 'Total', amount: total, total: true });
    return {
        ...state,
        productCost: cost,
    };
};

export function* productBuilderCostCalculate(action: { type: ProductBuilderAction, params: { product: Product, productConfiguration: ProductConfiguration; }; }) {
    yield put({ type: 'PRODUCT_BUILDER_LOADING_BEGIN' });
    yield put({ type: 'PRODUCT_BUILDER_COST_SET', params: { productConfiguration: action.params.productConfiguration } });
    yield put({ type: 'PRODUCT_BUILDER_LOADING_END' });
}

export function* productBuilderCostCalculateWatch() {
    yield takeEvery('PRODUCT_BUILDER_COST_CALCULATE', productBuilderCostCalculate);
}